import { toast } from 'react-toastify';
import {
    Box,
    Button,
    Input,
    Select,
    Flex,
    InputGroup, InputRightElement, Heading,
} from '@chakra-ui/react';
import './model.css'
import FlowireAPI from '../../../../../flowireapi/FlowireAPI';
import React, {useEffect, useRef, useState, useCallback} from 'react';
import {useAuth0} from '@auth0/auth0-react';
import {PopupButton, PopupLayout} from "../../../../PopupLayout/PopupLayout";
import AsyncSelect from 'react-select/async';
import totalOutputMB from "../../../services/unitBalance";

let extraDivsDictionary = {
    'Filters - Plate and frame': ['Mass Flow', 'Solid Concentration', 'Cycle Time', 'Pump Efficiency', 'Operating Pressure', 'Density Liquid', 'Density Solid'],
    'Tanks - cone roof': ['Mass Flow', 'Residence Time', 'Operating Level', 'Density'],
    'Tanks + Agitator': ['Mass Flow', 'Residence Time', 'Operating Level', 'Density', 'Agitation Application'],
    'Reactors - Jacketed, agitated': ['Mass Flow', 'Residence Time', 'Operating Level', 'Tank Height', 'Density', 'Agitation Application', 'Inlet Temperature', 'Reaction Temperature', 'Heat Transfer Coefficient'],
    'Extruder - Screw': ['Mass Flow'],
    'Agitators & mixers - Static mixer': ['Mass Flow', 'Density'],
    'Custom': ['Mass Flow'],
    //'Crushers - Jaw crusher': ['Mass Flow'],
    //'Crushers - Gyratory crusher': ['Mass Flow'],
    //'Crushers - Reversible hammer mill': ['Mass Flow'],
    //'Crushers - Ball mill': ['Mass Flow'],
    //'Haulage - Electric Fleet': ['Mass Flow'],
    //'Haulage - Diesel Fleet': ['Mass Flow'],
    'Filters - Ultrafiltration (>0.8 L/s)':['Flow','Number'],
    'Filters - Ultrafiltration (<0.8 L/s)':['Flow','Number'],
    'Screens - Grizzly Bar':['Mass Flow', 'Solid Concentration', 'Cycle Time', 'Density Liquid', 'Density Solid'],
    'Pumps and drivers - Single stage centrifugal': ['Mass Flow', 'Density', 'Operating Pressure', 'Pump Efficiency'],
    'Pumps - Rotary Screw': ['Mass Flow', 'Density', 'Operating Pressure', 'Pump Efficiency'],
    'Centrifuges - Continuous Extraction (<2.2 L/s)': ['Mass Flow', 'Density'],
    'Centrifuges - Continuous Extraction (>2.2 L/s)': ['Mass Flow', 'Density'],
    //'Electrodialysis':['Flow','Number'],
    //'Aeration Basin (incl. aeration)':['Flow','Residence Time', 'Number'],
    'Membrane Spiral':['Flow', 'Number'],
    //'Thickener':['Area', 'Number'],
    'RO (<1600 m2)':['Flow', 'Number'],
    'RO (>1600 m2)':['Flow', 'Number'],
    'Dryers - Spray dryer':['Mass Flow'],
    'Pressure Exchange + Rotary Pump': ['Mass Flow', 'Density', 'Operating Pressure', 'Pump Efficiency', 'PX Flow', 'Energy Recovery'],
    // 'Pressure vessels - Vertical': ['S (shell mass)'],
};

let extraDivsDictionarySectors = {
    'Filters - Plate and frame': ['Default'],
    'Tanks - cone roof': ['Default'],
    'Tanks + Agitator': ['Default'],
    'Reactors - Jacketed, agitated': ['Default'],
    'Extruder - Screw': ['Manufacturing'],
    'Agitators & mixers - Static mixer': ['Default'],
    'Custom': ['Default'],
    //'Crushers - Jaw crusher': ['Mining'],
    //'Crushers - Gyratory crusher': ['Mining'],
    //'Crushers - Reversible hammer mill': ['Mining'],
    //'Crushers - Ball mill': ['Mining'],
    //'Haulage - Electric Fleet': ['Mining', "Transport"],
    //'Haulage - Diesel Fleet': ['Mining', "Transport"],
    'Filters - Ultrafiltration (>0.8 L/s)':['Default'],
    'Filters - Ultrafiltration (<0.8 L/s)':['Default'],
    'Screens - Grizzly Bar':['Default'],
    'Pumps and drivers - Single stage centrifugal': ['Default'],
    'Pumps - Rotary Screw': ['Default'],
    'Centrifuges - Continuous Extraction (<2.2 L/s)': ['Default'],
    'Centrifuges - Continuous Extraction (>2.2 L/s)': ['Default'],
    //'Electrodialysis':['Default'],
    //'Aeration Basin (incl. aeration)':['Default'],
    'Membrane Spiral':['Default'],
    //'Thickener': ['Default'],
    'RO (<1600 m2)': ['Default'],
    'RO (>1600 m2)': ['Default'],
    'Dryers - Spray dryer':['Manufacturing', 'Default', 'Mining'],
    'Pressure Exchange + Rotary Pump': ['Default'],

    // 'Pressure vessels - Vertical': ['S (shell mass)'],
};

// TODO: give these field names in the back end so we don't have to use the labels to match values when posting data
let extraDivsDictionaryPost = {
    'Mass Flow': 'Mass Flow', //removed the units because some mass flow is in tonnes/hr instead of m3/day
    'Flow':'Flow',
    'Density': 'Density (kg/m3)',
    'Operating Level': 'Operating Level (%)',
    'Agitation Application': 'Agitation Application',
    'Reaction Temperature': 'Reaction Temperature (°C)',
    'Inlet Temperature': 'Inlet Temperature (°C)',
    'Heat Transfer Coefficient': 'Heat Transfer Coefficient (W/m2°C)',
    'Tank Height': 'Tank Height (m)',
    'S (volume)': 'S (volume - m3)',
    'Residence Time': 'Residence Time (hrs)',
    'Agitation Application': 'Agitation Application',
    'Reaction Temperature': 'Reaction Temperature (°C)',
    'S (shell mass)': 'S (shell mass- m3)',
    'S': 'S (tonnes/hr)',
    'Number':'Number',
    'Area': 'Area (m2)',
    'Solid Concentration': 'Solid Concentration (kg/m3)',
    'Cycle Time': 'Cycle Time (hrs)',
    'Pump Efficiency': 'Pump Efficiency (%)',
    'Operating Pressure': 'Operating Pressure (Pa)',
    'Density Liquid': 'Density Liquid (kg/m3)',
    'Density Solid': 'Density Solid (kg/m3)',
    'PX Flow': 'PX Flow (m3/day)',
    'Energy Recovery': 'Energy Recovery (%)',
};


let extraDivsDictionaryUnits = {
    'Custom': ['tonnes/day'],
    'Filters - Plate and frame': ['tonnes/day', 'kg/m3', 'hrs', '%', 'Pa', 'kg/m3', 'kg/m3'],
    'Tanks - cone roof': ['tonnes/day', 'hrs', '%', 'kg/m3'],
    'Tanks + Agitator': ['tonnes/day', 'hrs', '%', 'kg/m3', ' '],
    'Reactors - Jacketed, agitated': ['tonnes/day', 'hrs', '%', 'm', 'kg/m3', ' ', '°C', '°C', 'W/m2°C'],
    'Extruder - Screw': ['tonnes/day'],
    'Agitators & mixers - Static mixer': ['tonnes/day', 'kg/m3'],
    // 'Pressure vessels - Vertical': ['m3'],
    //'Crushers - Jaw crusher': ['tonnes/h'],
    //'Crushers - Gyratory crusher': ['tonnes/h'],
    //'Crushers - Reversible hammer mill': ['tonnes/h'],
    //'Crushers - Ball mill': ['tonnes/h'],
    //'Haulage - Electric Fleet': ['tonnes/h'],
    //'Haulage - Diesel Fleet': ['tonnes/h'],
    'Filters - Ultrafiltration (>0.8 L/s)':['tonnes/day', ' '],
    'Filters - Ultrafiltration (<0.8 L/s)':['tonnes/day', ' '],
    'Screens - Grizzly Bar':['tonnes/day', 'kg/m3', 'hrs', 'kg/m3', 'kg/m3'],
    'Pumps and drivers - Single stage centrifugal': ['tonnes/day', 'kg/m3', 'Pa', '%'],
    'Pumps - Rotary Screw': ['tonnes/day', 'kg/m3', 'Pa', '%'],
    'Centrifuges - Continuous Extraction (<2.2 L/s)': ['tonnes/day', 'kg/m3'],
    'Centrifuges - Continuous Extraction (>2.2 L/s)': ['tonnes/day', 'kg/m3'],
    //'Electrodialysis':['tonnes/day', ' '],
    //'Aeration Basin (incl. aeration)':['tonnes/day', 'hrs',' '],
    'Membrane Spiral':['tonnes/day', ' '],
    //'Thickener':['m2', ' '],
    'RO (<1600 m2)':['tonnes/day', ' '],
    'RO (>1600 m2)':['tonnes/day', ' '],
    'Dryers - Spray dryer':['tonnes/day'],
    'Pressure Exchange + Rotary Pump': ['tonnes/day', 'kg/m3', 'Pa', '%', 'm3/day', '%'],
};

const PropertyPopup = ({getMADropdownData, graph, pageX, pageY, modelId, econVars, isOpen, onClose, reCalculate, updateGraphs, orgSectors}) => {
    const [version, setVersion] = useState(0);
    const [selectedFeedDropDownValue, setSelectedFeedDropDownValue] = useState("");
    const [showCostAndSize, setShowCostAndSize] = useState(false);
    const [showCostAndSizeButton, setShowCostAndSizeButton] = useState(false);
    const {isAuthenticated, getIdTokenClaims} = useAuth0();
    const [isCostAndSizePressed, setIsCostAndSizePressed] = useState(false);
    const [displayChemicalCostingLookup, setDisplayChemicalCostingLookup] = useState(false);
    const [chemicalCostingOptions, setChemicalCostingOptions] = useState([]);
    const [chemicalCostingPrice, setChemicalCostingPrice] = useState(0);
    const [selectedChemical, setSelectedChemical] = useState("");
    const [dictionaryUnits, setDictionaryUnits] = useState([]);
    const [selectedCostAndSizeDropdown, setSelectedCostAndSizeDropdown] = useState(null);
    const [isFeedUnit, setIsFeedUnit] = useState(false);
    const [components, setComponents] = useState([])

    const componentRef = useRef(null);
    const forceUpdate = useCallback(() => {
        setVersion(v => v + 1);
        }, []);
    const updateRef = useRef(forceUpdate);
    const unit = graph.getCell(modelId);
    const unitNumber = unit.prop('unitNumber') || '';
    const popupClassName = `property-popup-${modelId}`;
    const popupRef = useRef(null);
    const [apiParameters, setApiParameters] = useState([]);


    
    const handleUpdate = useCallback(() => {
        if (updateRef.current) {
            updateRef.current();
        }
    }, []);

    const validateInputs = useCallback((dataToSend) => {
        const requiredFields = extraDivsDictionary[unit.attributes['selectedDropdownValue']] || [];
        for (const field of requiredFields) {
            const fieldName = extraDivsDictionaryPost[field] || field;
            const value = dataToSend[fieldName];
            
            if (value === undefined || value === null || value === '') {
                throw new Error(`${fieldName} is required`);
            }
        }
    }, [unit]);

    useEffect(() => {
        updateRef.current = forceUpdate;
    }, [forceUpdate]);

    useEffect(() => {

        if (unit.attributes['equipment_Properties']['selectedFeedDropDownValue']) {
            setSelectedFeedDropDownValue(unit.attributes['equipment_Properties']['selectedFeedDropDownValue']);
        } else {
            setSelectedFeedDropDownValue("Total Feed");
            unit.attributes['equipment_Properties']['selectedFeedDropDownValue'] = "Total Feed";
        }

        if (unit.attributes['selectedDropdownValue']) {
            setSelectedCostAndSizeDropdown({value: unit.attributes['selectedDropdownValue'], label: unit.attributes['selectedDropdownValue']});
        } else {
            unit.attributes['selectedDropdownValue'] = "Custom"; //this is where the default is set
            setSelectedCostAndSizeDropdown({value: unit.attributes['selectedDropdownValue'], label: unit.attributes['selectedDropdownValue']});
        }

          // If this is an API equipment, load its parameters
        if (unit.attributes['isApiEquipment'] && unit.attributes['apiEquipmentId']) {
            const selectedName = unit.attributes['selectedDropdownValue'];
            if (unit.attributes['equipment_Properties'][selectedName] && 
                unit.attributes['equipment_Properties'][selectedName]['parameters']) {
                // Use stored parameters
                setApiParameters(unit.attributes['equipment_Properties'][selectedName]['parameters']);
            } else {
                // Fetch parameters if not already loaded
                fetchApiEquipmentParameters(unit.attributes['apiEquipmentId'], selectedName);
            }
        }

        if (!unit.attributes['equipment_Properties'][unit.attributes['selectedDropdownValue']]) {
            unit.attributes['equipment_Properties'][unit.attributes['selectedDropdownValue']] = {};
        }

        if (!unit.attributes['equipment_Properties'][unit.attributes['selectedDropdownValue']][unit.attributes['selectedDropdownValue'] + 'Input2Value']) {
            unit.attributes['equipment_Properties'][unit.attributes['selectedDropdownValue']][unit.attributes['selectedDropdownValue'] + 'Input2Value'] = "";
        } else {
            unit.attributes['equipment_Properties'][unit.attributes['selectedDropdownValue']][unit.attributes['selectedDropdownValue'] + 'Input2Value'] = unit.attributes['equipment_Properties'][unit.attributes['selectedDropdownValue']][unit.attributes['selectedDropdownValue'] + 'Input2Value'];
        }

        let economicsData;

        if (['product', 'Product', 'feed', 'Feed'].includes(unit.attributes['equipment_Properties']['unitType'])) {
            economicsData = {'Cost': {'Value': 0, 'Units': 'USD/tonne'}};
        } else if (unit.attributes['equipment_Properties']['unitType'] !== 'Pipework') {
            economicsData = {
                'Opex': {'Value': 0, 'Units': 'USD/yr'},
                'Capex': {'Value': 0, 'Units': 'USD'},
                'Duty': {'Value': 0, 'Units': 'kW'}
            };
        }

        if (economicsData && !unit.prop('equipment_Economics')) {
            unit.prop('equipment_Economics', economicsData);
            getMADropdownData(graph)
        }

        unit.attributes['equipment_Properties'][unit.attributes['selectedDropdownValue']][unit.attributes['selectedDropdownValue'] + 'Input2Value'] = extraDivsDictionaryUnits[unit.attributes['selectedDropdownValue']];

        setShowCostAndSizeButton(!(unit.attributes['equipment_Properties']['unitType'] === "Feed" || unit.attributes['equipment_Properties']['unitType'] === "Product"));
        setIsFeedUnit(unit.attributes['equipment_Properties']['unitType'] === 'feed' || unit.attributes['equipment_Properties']['unitType'] === 'Feed');
        setComponents(getOutletComponents(graph, unit));

        setDictionaryUnits(Object.keys(extraDivsDictionarySectors).filter((key) => {
            if(extraDivsDictionarySectors[key] && extraDivsDictionarySectors[key].includes('Default')) {
                return true;
            }
            for (let sector of orgSectors) {
                if (extraDivsDictionarySectors[key] && (extraDivsDictionarySectors[key].includes(sector))) {
                    return true;
                }
            }
            return false;
        }));
    }, []);

    const handleChemicalCostingChange = useCallback((selectedOption) => {
        if (selectedOption == null) {
            setChemicalCostingPrice(0);
            return;
          }
  
          setSelectedChemical(selectedOption.value);
        
          const selectedValue = selectedOption.value.toLowerCase();
        
          for (let i = 0; i < chemicalCostingOptions.length; i++) {
            if (
              chemicalCostingOptions[i].name.toLowerCase() === selectedValue ||
              chemicalCostingOptions[i].CASRN.toLowerCase() === selectedValue
            ) {
              setChemicalCostingPrice(chemicalCostingOptions[i].price);
              break;
            }
          }
    }, [chemicalCostingOptions]);
    

    const promiseOptions = inputValue => new Promise(resolve => {
        fetchChemicalCostingData(inputValue).then(data => {
            resolve(data);
        }).catch(error => {
            console.error('Error fetching data:', error);
            resolve([]);
        })
    });

    const fetchChemicalCostingData = async (inputValue) => {
        try {
          const response = await FlowireAPI.authGet('/api/getchemicals', getIdTokenClaims, isAuthenticated);
      
          if (response['chemicals']) {
            setChemicalCostingOptions(response['chemicals']);
      
            // Create options with name, CASRN, and price
            const chemicalOptions = response['chemicals'].flatMap((chemical) => [
              { value: chemical.name.toLowerCase(), label: chemical.name, price: chemical.price },
              { value: chemical.CASRN.toLowerCase(), label: chemical.CASRN, price: chemical.price },
            ]);
      
            // Filter options based on the inputValue
            const filteredData = inputValue
              ? chemicalOptions.filter((item) => 
                  item.value.includes(inputValue.toLowerCase()) || item.label.toLowerCase().includes(inputValue.toLowerCase())
                )
              : chemicalOptions;
      
            return filteredData;
          }
        } catch (error) {
          console.error('Error fetching chemical data:', error);
          return [];
        }
      };

    const getCostAndSizeOptions = inputValue => new Promise(resolve => {
        const getOptions = async (inputValue) => {
          // Start with dictionary units using the extraDivsDictionarySectors directly
          let options = Object.keys(extraDivsDictionarySectors)
            .filter((key) => {
              if(extraDivsDictionarySectors[key] && extraDivsDictionarySectors[key].includes('Default')) {
                return true;
              }
              for (let sector of orgSectors) {
                if (extraDivsDictionarySectors[key] && (extraDivsDictionarySectors[key].includes(sector))) {
                  return true;
                }
              }
              return false;
            })
            .map(unit => ({
              value: unit, 
              label: unit,
              isApiEquipment: false
            }));
          
          console.log("Getting cost and size options, starting with local options:", options.length);
          
          // Fetch org-specific equipment types if authenticated
          if (isAuthenticated) {
            try {
              console.log("Attempting to fetch custom costing data...");
              const response = await FlowireAPI.authGet(
                `/api/getcustomcosting`, 
                getIdTokenClaims, 
                isAuthenticated
              );
              
              console.log('API response for custom costing:', response);
      
              // Handle the actual response format - it has scripts array instead of equipmentTypes
              if (response && response.scripts && Array.isArray(response.scripts)) {
                // Map API equipment types to dropdown options
                const apiOptions = response.scripts.map(item => ({
                  value: item.id,
                  label: item.id, // Or item.name if available
                  isApiEquipment: true
                }));
                
                console.log("Adding API options:", apiOptions.length);
                options = [...options, ...apiOptions];
              } else {
                console.log("No valid scripts found in API response");
              }
            } catch (error) {
              console.error('Error fetching org equipment types:', error);
            }
          } else {
            console.log("Not authenticated, skipping API fetch");
          }
          
          // Filter by input value if provided
          if (inputValue.trim() !== "") {
            options = options.filter(option => 
              option.label.toLowerCase().includes(inputValue.toLowerCase())
            );
            console.log("Filtered options by input value:", options.length);
          }
          
          console.log("Final options:", options);
          return options;
        }
      
        getOptions(inputValue).then(data => {
          resolve(data);
        }).catch(error => {
          console.error('Error in getCostAndSizeOptions:', error);
          // Generate local options directly here too, in case of error
          const localOptions = Object.keys(extraDivsDictionarySectors)
            .filter((key) => {
              if(extraDivsDictionarySectors[key] && extraDivsDictionarySectors[key].includes('Default')) {
                return true;
              }
              for (let sector of orgSectors) {
                if (extraDivsDictionarySectors[key] && (extraDivsDictionarySectors[key].includes(sector))) {
                  return true;
                }
              }
              return false;
            })
            .map(unit => ({
              value: unit, 
              label: unit,
              isApiEquipment: false
            }));
          console.log("Resolving with local options after error:", localOptions.length);
          resolve(localOptions);
        });
    });

    const dutyFunction = () => {
        var element = modelId
        var globalObjectsList = econVars
        let unit = graph.getCell(element)
        let totalFlow = 0
        //check if the unit is a feed or product, then it doesn't need a duty
        try {
            if (unit.attributes['equipment_Properties']['unitType'] != 'feed' || unit.attributes['equipment_Properties']['unitType'] != 'Feed' || unit.attributes['equipment_Properties']['unitType'] != 'product' || unit.attributes['equipment_Properties']['unitType'] != 'Product') {
                
                if (unit.attributes['equipment_Economics']['Opex'] && 
                unit.attributes['equipment_Economics']['Opex']['Value'] > 0 &&
                unit.attributes['equipment_Economics']['Opex']['isApiCalculated']) {
                return; // Only skip if it's API-calculated
            }
    
                //utputStreams = graph.getConnectedLinks(element)
                //let totalFlow = parseFloat(graph.getConnectedLinks(unit)[0].attributes['complete_Stream_Properties']['totalFlow'])
                let streamList = graph.getLinks(element)
                // if(!unit.attributes['equipment_Economics']['Duty']) unit.attributes['equipment_Economics']['Duty'] = {}
                let duty = unit.attributes['equipment_Economics']['Duty']['Value']
                let outputStreams = unit.attributes['equipment_Properties']['outputStreams']
                //write a for loop for calculting the total flow based on the flow of each outputStream
                for (let i = 0; i < outputStreams.length; i++) {
                    let result = streamList.find(item => item.attributes && item.attributes.CustomName === parseInt(outputStreams[i]));
                    let specificFlow = result.attributes['complete_Stream_Properties']['totalFlow']
                    //add the value of total flow to a variable
                    totalFlow += specificFlow
                }
                let totalDuty = duty //removing scaling
                //reads the duty from the elements duty
                //retreive the electricity cost from the global objects list
    
                let electricityCost = globalObjectsList.elecCost
                let opexUnit = totalDuty * (electricityCost / 1000) * 8000
                //save the opexUnit into the opex div
                unit.attributes['equipment_Economics']['Opex']['Value'] = Number(opexUnit.toFixed(2))
                // console.log(unit.attributes['equipment_Economics']['Opex']['Value'])
            }
        } catch (e) {
        }
    }

    
    const handleDropdownChange = (e) => {
        setSelectedFeedDropDownValue(e.target.value);
        unit.attributes['equipment_Properties']['selectedFeedDropDownValue'] = e.target.value;
    }

    const handleDropDownContainerChange = (e) => {
        setSelectedCostAndSizeDropdown(e);
        
        const isApiItem = e.isApiEquipment || false;
        const selectedName = e.label;
        
        // Store current selection metadata
        unit.attributes['selectedDropdownValue'] = selectedName;
        unit.attributes['isApiEquipment'] = isApiItem;

        // Reset the API parameters if switching to a non-API item
        if (unit.attributes['equipment_Economics'] && 
        unit.attributes['equipment_Economics']['Opex']) {
        unit.attributes['equipment_Economics']['Opex']['isApiCalculated'] = false;
        }
        
        // Ensure the equipment_Properties structure exists for this equipment type
        if (!unit.attributes['equipment_Properties'][selectedName]) {
          unit.attributes['equipment_Properties'][selectedName] = {};
        }
        
        if (isApiItem) {
          // Store equipment ID for API calls
          unit.attributes['apiEquipmentId'] = e.value;
          
          // Only fetch parameters if we don't already have them
          if (!unit.attributes['equipment_Properties'][selectedName]['parametersLoaded']) {
            fetchApiEquipmentParameters(e.value, selectedName);
          } else {
            // If parameters were already loaded, just update the UI state
            const storedParameters = unit.attributes['equipment_Properties'][selectedName]['parameters'] || [];
            setApiParameters(storedParameters);
          }
        } else {
          // Initialize standard equipment with default units if needed
          if (!unit.attributes['equipment_Properties'][selectedName][selectedName + 'Input2Value']) {
            unit.attributes['equipment_Properties'][selectedName][selectedName + 'Input2Value'] = 
              extraDivsDictionaryUnits[selectedName];
          }
          
          // Apply default values only if they don't exist yet
          const defaultValues = getDefaultValuesForDropdown(selectedName, unit, modelId, graph);
          for (const field in defaultValues) {
            if (!unit.attributes['equipment_Properties'][selectedName][field]) {
              unit.attributes['equipment_Properties'][selectedName][field] = defaultValues[field];
            }
          }
        }
        
        forceUpdate();
    };

    const fetchApiEquipmentParameters = async (equipmentId, selectedName) => {
        try {
          // Get the script data directly from the custom costing API
          const response = await FlowireAPI.authGet(
            `/api/getcustomcosting`, 
            getIdTokenClaims, 
            isAuthenticated
          );
          
          console.log('Custom costing response:', response);
          
          // Find the specific script by ID
          if (response && response.scripts && Array.isArray(response.scripts)) {
            const script = response.scripts.find(s => s.id === equipmentId);
            
            if (script && script.inputs && Array.isArray(script.inputs)) {
              console.log('Found script inputs:', script.inputs);
              
              // Process the inputs array - it has the format we want
              const formattedParams = script.inputs.map(input => ({
                name: input.key,
                displayName: input.key.charAt(0).toUpperCase() + input.key.slice(1).replace(/([A-Z])/g, ' $1').trim(),
                unit: input.unit,
                required: true
              }));
              
              // Store the formatted parameters in the unit for future reference
              unit.attributes['equipment_Properties'][selectedName]['parameters'] = formattedParams;
              unit.attributes['equipment_Properties'][selectedName]['parametersLoaded'] = true;
              
              setApiParameters(formattedParams);
              
              // Set initial values in unit attributes (only if not already set)
              script.inputs.forEach(input => {
                // Only set default value if the parameter doesn't already have a value
                if (unit.attributes['equipment_Properties'][selectedName][input.key] === undefined) {
                  unit.attributes['equipment_Properties'][selectedName][input.key] = input.value || '';
                }
              });
              
              forceUpdate();
            } else {
              console.error('Script has no inputs array:', script);
              toast.error('Selected script has no input parameters');
            }
          } else {
            console.error('Invalid API response structure:', response);
            toast.error('Failed to load parameters: invalid API response');
          }
        } catch (error) {
          console.error('Error fetching script parameters:', error);
          toast.error('Failed to load parameters for this equipment type');
        }
    };

    const getDefaultValuesForDropdown = (dropdownValue,unit,modelId,graph) => {
        let defaultValues = {};
        let totalMassOut = (totalOutputMB(unit,modelId,graph));
        //let densitySolid = 2265; //for copper ore
        //let massFlowSolid = (totalMassOut*densitySolid)/24;
        let numberOfUnits = 1;
        // Add default values for each dropdown option as needed
        switch (dropdownValue) {
            case 'Tanks - cone roof':
                defaultValues = {
                    'Mass Flow': totalMassOut,
                    'Operating Level (%)': 90,
                    'Density (kg/m3)': 1000,
                };
                break;

            case 'Tanks + Agitator':
                defaultValues = {
                    'Mass Flow': totalMassOut,
                    'Operating Level (%)': 90,
                    'Density (kg/m3)': 1000,
                    'Agitation Application': 'blending/mixing',
                };
                break;

            case 'Reactors - Jacketed, agitated':
                defaultValues = {
                    'Mass Flow': totalMassOut,
                    'Operating Level (%)': 90,
                    'Density (kg/m3)': 1000,
                    'Tank Height (m)': 8,
                    'Agitation Application': 'blending/mixing',
                    'Heat Transfer Coefficient (W/m2°C)': 15,
                    'Inlet Temperature (°C)': 25,
                };
                break;

            case 'Agitators & mixers - Static mixer':
                defaultValues = {
                    'Mass Flow': totalMassOut,
                    'Density (kg/m3)': 1000,
                };
                break;

            case 'Extruder - Screw':
                    defaultValues = {
                        'Mass Flow': totalMassOut,
                    };
                    break;

            case 'Custom':
                defaultValues = {
                    'Mass Flow': totalMassOut,
                };
                break;

            case 'Filters - Plate and frame':
                defaultValues = {
                    'Mass Flow': totalMassOut,
                    'Pump Efficiency (%)': 70,
                    'Operating Pressure (Pa)': 100000,
                    'Density Liquid (kg/m3)': 1000,
                };
                break;

            case 'Pumps and drivers - Single stage centrifugal':
                defaultValues = {
                    'Mass Flow': totalMassOut,
                    'Pump Efficiency (%)': 70,
                    'Operating Pressure (Pa)': 100000,
                    'Density (kg/m3)': 1000,
                };
                break;
            
            case 'Pumps - Rotary Screw':
                defaultValues = {
                    'Mass Flow': totalMassOut,
                    'Pump Efficiency (%)': 70,
                    'Operating Pressure (Pa)': 100000,
                    'Density (kg/m3)': 1000,
                };
                break;

            case 'Centrifuges - Continuous Extraction (<2.2 L/s)':
                defaultValues = {
                    'Mass Flow': totalMassOut,
                    'Density (kg/m3)': 1000,
                };
                break;

            case 'Centrifuges - Continuous Extraction (>2.2 L/s)':
                defaultValues = {
                    'Mass Flow': totalMassOut,
                    'Density (kg/m3)': 1000,
                };
                break;

            case 'Crushers - Jaw crusher':
                defaultValues = {
                    'Mass Flow': totalMassOut/24,
                };
                break;

            case 'Crushers - Gyratory crusher':
                defaultValues = {
                    'Mass Flow': totalMassOut/24,
                };
                break;
            
            case 'Crushers - Reversible hammer mill':
                defaultValues = {
                    'Mass Flow': totalMassOut/24,
                };
                break;

            case 'Crushers - Ball mill':
                defaultValues = {
                    'Mass Flow': totalMassOut/24,
                };
                break;

            case 'Haulage - Electric Fleet':
                defaultValues = {
                    'Mass Flow': totalMassOut,
                };
                break;

            case 'Haulage - Diesel Fleet':
                    defaultValues = {
                        'Mass Flow': totalMassOut,
                    };
                break;
            case 'Filters - Ultrafiltration (>0.8 L/s)':
                    defaultValues = {
                        'Flow': totalMassOut,
                        'Number' : 1
                    };
                break;
            case 'Filters - Ultrafiltration (<0.8 L/s)':
                    defaultValues = {
                        'Flow': totalMassOut,
                        'Number' : 1
                    };
                break;
            case 'Screens - Grizzly Bar':
                    defaultValues = {
                        'Mass Flow': totalMassOut,
                        'Density Liquid (kg/m3)': 1000,
                    };
                    break;
            case 'Electrodialysis':
                    defaultValues = {
                        'Flow': totalMassOut,
                        'Number' : 1
                    };
                break;
            case 'Membrane Spiral':
                    defaultValues = {
                        'Flow': totalMassOut,
                        'Number' : 1
                    };
                break;
            case 'RO (<1600 m2)':
                    defaultValues = {
                        'Flow': totalMassOut,
                        'Number' : 1
                    };
                break;
            case 'RO (>1600 m2)':
                    defaultValues = {
                        'Flow': totalMassOut,
                        'Number' : 1
                    };
                break;
            case 'Aeration Basin (incl. aeration)':
                    defaultValues = {
                        'Flow': totalMassOut,
                        'Residence Time (hrs)': 0.5,
                        'Number' : 1
                    };
                break;
            case 'Thickener':
                    defaultValues = {
                        'Number' : 1
                    };
                break;
            case 'Dryers - Spray dryer':
                    defaultValues = {
                        'Mass Flow': totalMassOut,
                    };
                break;
            case 'Pressure Exchange + Rotary Pump':
                    defaultValues = {
                        'Mass Flow': totalMassOut,
                        'Density (kg/m3)': 1000,
                        'Operating Pressure (Pa)': 100000,
                        'Pump Efficiency (%)': 70,
                        'Energy Recovery (%)': 60
                    };
                break;
            
            // Add more cases for other dropdown options if needed
            default:
                break;
        }

        return defaultValues;
    };


    const handleExtraInputChange = (e, field) => {
        const equipmentType = unit.attributes['selectedDropdownValue'];
        if (!unit.attributes['equipment_Properties'][equipmentType]) {
            unit.attributes['equipment_Properties'][equipmentType] = {};
        }
        unit.attributes['equipment_Properties'][equipmentType][field] = e.target.value;
        forceUpdate();
    };

    // Update your handleCostAndSize function
    const handleCostAndSize = () => {
        const willExpand = !showCostAndSize;
        
        setShowCostAndSize(willExpand);
        setIsCostAndSizePressed(willExpand);
        
        // Use setTimeout to ensure state has updated
        setTimeout(() => {
            // Look for the Card element in the DOM
            const popupCards = document.querySelectorAll('.chakra-card');
            popupCards.forEach(card => {
                // Check if this card contains our popup content
                if (card.querySelector(`[data-model-id="${modelId}"]`)) {
                    // Apply direct style changes to the card
                    card.style.height = willExpand ? '550px' : '350px';
                    
                    // Find the content box to adjust scrollable height
                    const contentBox = card.querySelector('[overflow="auto"]');
                    if (contentBox) {
                        contentBox.style.maxHeight = willExpand ? '450px' : '250px';
                    }
                    
                    console.log('Resized popup for model', modelId);
                }
            });
        }, 10);
    };

    const handleValueChange = (e, econName) => {
        unit.attributes['equipment_Economics'][econName]['Value'] = e.target.value
        if (unit.attributes['equipment_Properties']['unitType'] === 'Feed' || unit.attributes['equipment_Properties']['unitType'] === 'Product') {
            delete unit.attributes['costingChemical']
        }
        forceUpdate()
    }

    const handleUnitChange = (e, econName) => {
        unit.attributes['equipment_Economics'][econName]['Units'] = e.target.value
        forceUpdate()
    }

    const handleCalculate = async () => {
        try {
          if (!unit.attributes['equipment_Properties']) {
            toast.error('Equipment properties not found');
            return;
          }
      
          const selectedName = unit.attributes['selectedDropdownValue'];
          const isApiEquipment = unit.attributes['isApiEquipment'];
          
          // Prepare data to send
          let dataToSend = {};
          
          if (unit.attributes['equipment_Properties'][selectedName]) {
            if (isApiEquipment) {
              // For API equipment, create values object for executecustomcosting endpoint
              const parameterValues = {};
              
              // Get all parameter values from the form
              apiParameters.forEach(param => {
                const value = unit.attributes['equipment_Properties'][selectedName][param.name];
                parameterValues[param.name] = value !== '' ? parseFloat(value) || value : '';
              });
              
              // Format payload according to the API expectations
              dataToSend = {
                script_name: unit.attributes['apiEquipmentId'],
                values: parameterValues
              };
            } else {
              // For standard equipment, use existing format
              let propData = {};
              let propDataKeys = Object.keys(unit.attributes['equipment_Properties'][selectedName]);
              
              propDataKeys.forEach(key => {
                if (!key.endsWith('Input2Value')) {
                  propData[key] = unit.attributes['equipment_Properties'][selectedName][key];
                }
              });
              propData['unitName'] = selectedName;
              dataToSend = propData;
            }
          }
      
          // Validate inputs based on type
          if (isApiEquipment) {
            validateApiInputs(dataToSend.values);
          } else {
            validateStandardInputs(dataToSend);
          }
      
          // Call appropriate API endpoint
          let response;
          if (isApiEquipment) {
            console.log('Executing custom costing with data:', dataToSend);
            response = await FlowireAPI.authPost('/api/executecustomcosting', dataToSend, getIdTokenClaims, isAuthenticated);
            
            // Handle response from custom costing API
            if (response && response.outputs) {
              console.log('Custom costing response:', response);
              unit.attributes['equipment_Economics']['Capex']['Value'] = response.outputs.capex || 0;
              unit.attributes['equipment_Economics']['Opex']['Value'] = response.outputs.opex || 0;
              if ((response.outputs.opex || 0) !== 0) {
                    unit.attributes['equipment_Economics']['Opex']['isApiCalculated'] = true;
              }
              unit.attributes['equipment_Economics']['Duty']['Value'] = response.outputs.duty || 0;
              toast.success('Custom calculation completed successfully');
              console.log(unit.attributes['equipment_Economics']['Opex']['isApiCalculated']);
            } else {
              throw new Error('Invalid response format from custom calculation');
            }
          } else {
            // Standard equipment calculation (unchanged)
            console.log('Calculating standard equipment with data:', dataToSend);
            response = await FlowireAPI.authPost('/api/econ/equipmentsizing', dataToSend, getIdTokenClaims, isAuthenticated);
            
            // Handle standard response format
            if (response && response[0] && response[1]) {
              unit.attributes['equipment_Economics']['Capex']['Value'] = response[0].result;
              unit.attributes['equipment_Economics']['Duty']['Value'] = response[1].duty;
              toast.success('Calculation completed successfully');
            } else {
              throw new Error('Invalid response from standard calculation');
            }
          }
          
          forceUpdate();
        } catch (error) {
          toast.error(error.message || 'Failed to calculate. Please check all inputs are filled correctly.');
          console.error('Calculation error:', error);
        }
    };
      
      // Split validation for clarity
    const validateStandardInputs = (dataToSend) => {
        const requiredFields = extraDivsDictionary[unit.attributes['selectedDropdownValue']] || [];
        for (const field of requiredFields) {
          const fieldName = extraDivsDictionaryPost[field] || field;
          const value = dataToSend[fieldName];
          
          if (value === undefined || value === null || value === '') {
            throw new Error(`${fieldName} is required`);
          }
        }
      };
      
    const validateApiInputs = (values) => {
        for (const param of apiParameters) {
          if (param.required) {
            const value = values[param.name];
            if (value === undefined || value === null || value === '') {
              throw new Error(`${param.displayName} is required`);
            }
          }
        }
    };

    const handleKeyDown = (e) => {
        if (e.key === "Enter") {
            updateGraphs()
            reCalculate()
        }
    }

    if (!isOpen) return null;
    dutyFunction()

    return (
        <>
            {isOpen && (
                <PopupLayout
                    title={`${unitNumber ? `Unit ${unitNumber} - ` : ''}${unit.attributes.attrs.shapename.innerHTML.replace(/<p>|<\/p>/g, '').includes('<br>') ? unit.attributes.unitType : unit.attributes.attrs.shapename.innerHTML.replace(/<p>|<\/p>/g, '')}`}
                    id = {modelId}
                    closeFunction={onClose}
                    pageX={pageX}
                    pageY={pageY}
                    minWidth="300px"
                    maxHeight="80vh"
                    minHeight="350px"
                    componentRef={componentRef}
                    // This will disable size memory but keep position memory
                    noSaveSize={true}
                    className={popupClassName} 
                    buttons={<>
                        {showCostAndSizeButton && (
                        <PopupButton 
                            onClick={handleCostAndSize}
                            className="flex items-center gap-1"
                        >
                            Cost And Size
                            {showCostAndSize ? (
                                <svg 
                                    xmlns="http://www.w3.org/2000/svg" 
                                    width="16" 
                                    height="16" 
                                    viewBox="0 0 24 24" 
                                    fill="none" 
                                    stroke="currentColor" 
                                    strokeWidth="2" 
                                    strokeLinecap="round" 
                                    strokeLinejoin="round"
                                >
                                    <path d="m18 15-6-6-6 6"/>
                                </svg>
                            ) : (
                                <svg 
                                    xmlns="http://www.w3.org/2000/svg" 
                                    width="16" 
                                    height="16" 
                                    viewBox="0 0 24 24" 
                                    fill="none" 
                                    stroke="currentColor" 
                                    strokeWidth="2" 
                                    strokeLinecap="round" 
                                    strokeLinejoin="round"
                                >
                                    <path d="m6 9 6 6 6-6"/>
                                </svg>
                            )}
                        </PopupButton>
                    )}
                        {showCostAndSize && (<PopupButton onClick={handleCalculate}>Calculate</PopupButton>)}
                        {(unit.attributes['equipment_Properties']['unitType'] == "Feed" || unit.attributes['equipment_Properties']['unitType'] == "Product") && (
                            <PopupButton onClick={() => setDisplayChemicalCostingLookup(!displayChemicalCostingLookup)}>Chemical Price Look Up</PopupButton>
                        )}
                    </>}>

                    <Box overflow="auto" data-model-id={modelId}>

                        {isFeedUnit && (
                            <Select value={selectedFeedDropDownValue}
                                    onChange={handleDropdownChange}>
                                {components.map(component => (
                                    <option key={component} value={component}>
                                        {component}
                                    </option>
                                ))}
                                <option key="Total Feed" value="Total Feed">Total Feed</option>
                            </Select>
                        )}

                        

                        {unit.prop('equipment_Economics') && Object.keys(unit.prop('equipment_Economics')).map(component => (
                            <Box key={component}>
                                <Flex
                                    p={2}
                                    justifyContent="space-between"
                                    alignItems="center">
                                    <Box width="40%">{component}</Box>
                                    <InputGroup width="60%">
                                        <InputRightElement pointerEvents="none" color="gray.600" background="gray.200"
                                                           fontWeight={600} width='auto' minWidth='var(--input-height)'
                                                           pl={1} pr={1}
                                                           fontSize=".9rem" borderTopRightRadius={8}
                                                           borderBottomRightRadius={8}
                                                           children={unit.prop('equipment_Economics')[component]['Units']}/>

                                        <Input
                                            disabled={isCostAndSizePressed}
                                            onKeyDown={handleKeyDown}
                                            value={unit.prop('equipment_Economics')[component]['Value']}
                                            onChange={(e) => {
                                                handleValueChange(e, component)
                                            }}
                                        />
                                        {/*<Input*/}
                                        {/*    disabled={isCostAndSizePressed}*/}
                                        {/*    onKeyDown={handleKeyDown}*/}
                                        {/*    value={unit.prop('equipment_Economics')[component]['Units']}*/}
                                        {/*    onChange={(e) => {*/}
                                        {/*        handleUnitChange(e, component)*/}
                                        {/*    }}*/}
                                        {/*/>*/}
                                    </InputGroup>
                                </Flex>
                                {unit.attributes['costingChemical'] ? (
                                    <Box float="right" fontStyle={"italic"} mb="2" mr="20">{unit.attributes['costingChemical']}</Box>
                                ) : <></>}
                            </Box>
                        ))}

                        {unit.attributes['equipment_Properties']['unitType'] !== 'product' && unit.attributes['equipment_Properties']['unitType'] !== 'Product' && unit.attributes['equipment_Properties']['unitType'] !== 'feed' && unit.attributes['equipment_Properties']['unitType'] !== 'Feed' && (
                            <Box className='dropdownContainer'>
                            <AsyncSelect
                                styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                className='drop-down'
                                menuPortalTarget={document.body}
                                loadOptions={getCostAndSizeOptions}
                                defaultOptions={true} // Change to true to trigger the loadOptions call
                                onChange={handleDropDownContainerChange}
                                value={selectedCostAndSizeDropdown}
                                noOptionsMessage={() => "No matching options"}
                                onMenuOpen={() => console.log("Dropdown menu opened")}
                                />                         
                            </Box>
                        )}

                        {showCostAndSize && unit.attributes['selectedDropdownValue'] && (
                        <React.Fragment key={unit.attributes['selectedDropdownValue']}>
                            {unit.attributes['isApiEquipment'] ? (
                            // API equipment parameters
                            apiParameters.map(param => (
                                <Flex key={param.name} p={2} justifyContent="space-between" alignItems="center">
                                <Box width="40%">{param.displayName}</Box>
                                <InputGroup width="60%">
                                    {param.unit && (
                                    <InputRightElement 
                                        pointerEvents="none" 
                                        color="gray.600"
                                        background="gray.200"
                                        fontWeight={600} 
                                        width='auto'
                                        minWidth='var(--input-height)'
                                        pl={1} pr={1}
                                        fontSize=".9rem"
                                        borderTopRightRadius={8}
                                        borderBottomRightRadius={8}
                                        children={param.unit}
                                    />
                                    )}
                                    <Input
                                    value={unit.attributes['equipment_Properties'][unit.attributes['selectedDropdownValue']][param.name] || ''}
                                    onChange={(e) => handleExtraInputChange(e, param.name)}
                                    />
                                </InputGroup>
                                </Flex>
                            ))
                            ) : (
                            // Standard equipment parameters (existing code)
                            unit.attributes['selectedDropdownValue'] in extraDivsDictionary &&
                            extraDivsDictionary[unit.attributes['selectedDropdownValue']].map((f, index) => {
                                const field = extraDivsDictionaryPost[f] || f;
                                const fieldUnit = (extraDivsDictionaryUnits[unit.attributes['selectedDropdownValue']][index] || '').trim();
                                return (
                                <Flex key={field} p={2} justifyContent="space-between" alignItems="center">
                                    <Box width="40%">{field}</Box>
                                    <InputGroup width="60%">
                                    {fieldUnit && (
                                        <InputRightElement 
                                        pointerEvents="none" 
                                        color="gray.600"
                                        background="gray.200"
                                        fontWeight={600} 
                                        width='auto'
                                        minWidth='var(--input-height)'
                                        pl={1} pr={1}
                                        fontSize=".9rem"
                                        borderTopRightRadius={8}
                                        borderBottomRightRadius={8}
                                        children={fieldUnit}
                                        />
                                    )}
                                    <Input
                                        value={unit.attributes['equipment_Properties'][unit.attributes['selectedDropdownValue']][field] || ''}
                                        onChange={(e) => handleExtraInputChange(e, field)}
                                    />
                                    </InputGroup>
                                </Flex>
                                );
                            })
                            )}
                        </React.Fragment>
                        )}

                        {displayChemicalCostingLookup && (
                            <Box borderTop='1px solid #eee' pt={4} mt="25">
                                <Heading mb="5" size='sm'>Chemical Costing Lookup</Heading>
                            <Flex justifyContent={"space-between"} alignItems={"center"}>
                                <Box width="50%">
                                    <AsyncSelect onChange={handleChemicalCostingChange} loadOptions={promiseOptions} isClearable defaultOptions menuPortalTarget={document.body} styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }} />
                                </Box>
                                <InputGroup width="50%">
                                    <InputRightElement pointerEvents="none" color="gray.600"
                                    background="gray.200"
                                    fontWeight={600} width='auto'
                                    minWidth='var(--input-height)'
                                    pl={1} pr={1}
                                    fontSize=".75rem"
                                    borderTopRightRadius={8}
                                    borderBottomRightRadius={8}
                                    children={"USD/tonne"}/>
                                    <Input readOnly disabled={true} value={chemicalCostingPrice}></Input>
                                </InputGroup>
                            </Flex>
                            <Button mt="2" float="right" colorScheme='blue' size="sm" onClick={() => {
                                unit.attributes['equipment_Economics']['Cost']['Value'] = chemicalCostingPrice;
                                unit.attributes['costingChemical'] = selectedChemical;
                                forceUpdate()
                            }}>Add</Button>
                            </Box>
                        )}
                    </Box>
                </PopupLayout>
            )}
        </>
    );

    };

function getOutletComponents(graph, feedUnit) {
    let stream = graph.getConnectedLinks(feedUnit)
    let streamComponents
    if (!stream || !stream[0] || !stream[0].attributes) {
        return []
    }

    streamComponents = Object.keys(stream[0].attributes['complete_Stream_Properties']['massFlow'])
    return streamComponents
}

export default PropertyPopup;